import React, { useEffect, useState } from "react";
import { VaultLogoMini } from "@/components/VaultLogo";
import { Menu, X } from "lucide-react";

const NAV_ITEMS = [
  { id: "opportunity", label: "Opportunity" },
  { id: "how-it-works", label: "How It Works" },
  { id: "philosophy", label: "Philosophy" },
  { id: "lrs", label: "The LRS Window" },
  { id: "why-us", label: "Why Us" },
  { id: "contact", label: "Contact" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#080808]/95 backdrop-blur-md border-b border-[#C9960C]/30"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <button
          onClick={() => go("hero")}
          data-testid="header-logo-btn"
          className="flex items-center gap-3 group cursor-pointer"
        >
          <VaultLogoMini size={34} />
          <span className="font-serif-display text-[#C9960C] text-lg sm:text-xl tracking-widest-extra uppercase font-semibold group-hover:text-[#F5D485] transition-colors">
            The Global Vault
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => go(item.id)}
              className="text-[#F5D485]/80 hover:text-[#C9960C] text-[13px] tracking-[0.18em] uppercase transition-colors cursor-pointer"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="header-cta-btn"
            onClick={() => go("contact")}
            className="hidden md:inline-flex items-center justify-center bg-transparent border border-[#C9960C] text-[#C9960C] px-5 py-2.5 uppercase tracking-[0.18em] text-xs font-medium hover:bg-[#C9960C] hover:text-[#080808] transition-colors duration-300 cursor-pointer"
          >
            Get in Touch
          </button>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden p-2 text-[#C9960C] cursor-pointer"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#080808] border-t border-[#C9960C]/30 px-6 py-6 space-y-4">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              onClick={() => go(item.id)}
              data-testid={`mobile-nav-${item.id}`}
              className="block w-full text-left text-[#F5D485] text-sm tracking-[0.2em] uppercase py-2 hover:text-[#C9960C] transition-colors cursor-pointer"
            >
              {item.label}
            </button>
          ))}
          <button
            data-testid="mobile-cta-btn"
            onClick={() => go("contact")}
            className="w-full mt-2 inline-flex items-center justify-center border border-[#C9960C] text-[#C9960C] px-5 py-3 uppercase tracking-[0.18em] text-xs font-medium hover:bg-[#C9960C] hover:text-[#080808] transition-colors cursor-pointer"
          >
            Get in Touch
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
